import { render, staticRenderFns } from "./FavoritesPage.vue?vue&type=template&id=9386a54e&"
import script from "./FavoritesPage.vue?vue&type=script&lang=js&"
export * from "./FavoritesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports